import script from "./WidgetMesTaches.vue?vue&type=script&setup=true&lang=js"
export * from "./WidgetMesTaches.vue?vue&type=script&setup=true&lang=js"

import "./WidgetMesTaches.vue?vue&type=style&index=0&id=c06651d2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c06651d2"]])

export default __exports__